import moment from 'moment';

import {
	mapActions,
	mapGetters
} from 'vuex';

import {
	DatePicker
} from 'element-ui';

import {
	cloneDeep
} from 'lodash';

import {
	EventBus
} from '@/support/event-bus';

import toastr from '@/support/toastr';

import SchoolClassList from '@/domains/school/class-list/main';
import LessonPlanningCopy from '@/domains/lessons/planning-copy/main';

export default {
	name: 'LessonPlanning',
	data: () => ({
		model: {},
		klass: {}
	}),
	components: {
		DatePicker,
		SchoolClassList,
		LessonPlanningCopy
	},
	computed: {
		...mapGetters([
			'getLoggedUser',
			'currentYear',
			'currentTheme',
			'getClass',
			'schoolClassLessonPlan'
		])
	},
	methods: {
		...mapActions([
			'updateSchoolClassLessonPlan',
			'putSchoolClassLessonPlan',
			'copySchoolClassLessonPlan'
		]),
		setPlanDate(date, lessonPlanIndex, plan, planIndex) {

			let payload = {
				index: planIndex,
				parentIndex: lessonPlanIndex,
				value: cloneDeep(plan)
			};

			payload.value.date = payload.value.date ? moment(date).format('YYYY-MM-DD') : null;

			this.updateSchoolClassLessonPlan(payload);

		},
		savePlanning(lessonPlanIndex) {

			let payload = {
				userId: this.getLoggedUser.id,
				schoolClassId: this.schoolClassLessonPlan[lessonPlanIndex].schoolClass.schoolClassId,
				themeId: this.currentTheme.schoolThemeId,
				year: this.currentYear,
				data: this.schoolClassLessonPlan[lessonPlanIndex].plans.filter((plan) => plan.date)
			};

			payload.data = payload.data.map((item) => {

				const {
					planId,
					date
				} = item;

				return {
					planId,
					date
				};

			});

			if (payload.data && payload.data.length) {

				return this.putSchoolClassLessonPlan(payload).then(() => {
					toastr.success(this.$gettext('Planejamento de aula salvo com sucesso!'));
				});

			}

			return toastr.warning(this.$gettext('Nenhuma data informada.'));

		},
		toggleCopy(index, status) {

			this.model.forEach((item) => {
				item.copyIsVisible = false;
			});

			if (status) {
				this.model[index].copyIsVisible = !this.model[index].copyIsVisible;
			}

		}
	},
	mounted() {

		EventBus.$on('classChanged', (klass) => {
			this[klass.context] = klass.data;
		});

		EventBus.$on('planning:toggle-copy', (index, status) => {
			this.toggleCopy(index, status);
		});

		EventBus.$on('schoolClassLessonPlanFetched', () => {

			const clone = cloneDeep(this.schoolClassLessonPlan);

			this.model = Object.assign(clone.map((value) => {

				value.copyIsVisible = false;

				return value;

			}), this.options);

		});

	}
};



// WEBPACK FOOTER //
// ./sources/domains/lessons/planning/index.js